<div class="info-corporativa-page">
  <div class="container">
    <header class="page-header">

    </header>

    <div class="content-section">
      <div class="table-section">
        <h2>Directorio</h2>
        <div class="table-container">
          <table class="info-table">
            <thead>
              <tr>
                <th>Cargo</th>
                <th>Nombre</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>Presidente</td>
                <td>Andrés Olivos Bambach</td>
              </tr>
              <tr>
                <td>Director</td>
                <td>Horacio Salamanca Uboldi</td>
              </tr>
              <tr>
                <td>Director</td>
                <td>Andrés Winter Salgado</td>
              </tr>
              <tr>
                <td>Director</td>
                <td>Arturo Silva Ortiz</td>
              </tr>
              <tr>
                <td>Director</td>
                <td>Marcelo Galvez Saldias</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>

      <div class="table-section">
        <h2>Administración</h2>
        <div class="table-container">
          <table class="info-table">
            <thead>
              <tr>
                <th>Cargo</th>
                <th>Nombre</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>Gerente General</td>
                <td>Inguer Pérez Borroto</td>
              </tr>
              <tr>
                <td>Gerente de Riesgo y Estrategia</td>
                <td>Alexey Khreshkov</td>
              </tr>
              <tr>
                <td>Gerente Comercial</td>
                <td>Marcela Osorio Manriquez</td>
              </tr>
              <tr>
                <td>Gerente de Auditoria Interna</td>
                <td>Heraclio Moreno Cornejo</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>

    <div class="back-section">
    <a href="/informaciones" class="back-button">
      <svg class="back-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
        <path d="M19 12H5M12 19l-7-7 7-7"/>
      </svg>
      Volver
    </a>
  </div>
    
  </div>
</div>


